import { Exchange } from '../proto/generated/common'
import { ExchangeTradingSession } from '../proto/generated/trading-calendar'

/** True during pre-open, regular, or post-close window for the symbol's exchange (streaming-eligible hours). */
export function isWithinChartLiveTradingHours(
    exchangeTradingSessions: ExchangeTradingSession[] | undefined,
    exchange: Exchange | undefined,
    atMs: number = Date.now()
): boolean {
    if (!exchangeTradingSessions?.length || exchange === undefined) return false
    const sess = exchangeTradingSessions.find((s) => s.exchange === exchange)
    if (!sess?.tradingSessions?.length) return false

    for (const ts of sess.tradingSessions) {
        if (atMs >= ts.preOpenStartTime && atMs <= ts.preOpenEndTime) return true
        if (atMs >= ts.startTime && atMs <= ts.endTime) return true
        if (atMs >= ts.postCloseStartTime && atMs <= ts.postCloseEndTime) return true
    }
    return false
}

/** Epoch ms boundaries after `now` that can change live vs not-live for this exchange. */
export function getFutureTradingSessionBoundaries(
    exchangeTradingSessions: ExchangeTradingSession[] | undefined,
    exchange: Exchange | undefined,
    nowMs: number = Date.now()
): number[] {
    if (!exchangeTradingSessions?.length || exchange === undefined) return []
    const sess = exchangeTradingSessions.find((s) => s.exchange === exchange)
    if (!sess?.tradingSessions?.length) return []

    const out: number[] = []
    for (const ts of sess.tradingSessions) {
        for (const t of [
            ts.preOpenStartTime,
            ts.preOpenEndTime,
            ts.startTime,
            ts.endTime,
            ts.postCloseStartTime,
            ts.postCloseEndTime
        ]) {
            if (t > nowMs) out.push(t)
        }
    }
    return out
}
